import React from 'react';
import ProductBrowser from '../ProductBrowser';
import { Modal } from '../../components';

export const AddProductModal = (props) => {
    const { show, onClose, projectId, tag } = props;

    return (
        <Modal
            fitContent
            show={show}
        >
            <div className="bg-black-5">
                <div className="divide-y-2 divide-solid">
                    <div className="sm:container pl-4 pr-4 pt-4">
                        <h1>Product Catalog</h1>
                        <ProductBrowser
                            show={show}
                            tag={tag}
                            projectId={projectId}
                        />
                    </div>
                    <div className="flex justify-end p-4">
                        <button
                            onClick={onClose}
                            type="button"
                            className="swegon-like-button contained"
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};
